export default __webpack_public_path__ + "static/media/jobvious_favicon.57726969.png";